// The one way to round/display numbers across the UI.
//
// Returns a Number, so trailing zeros are trimmed (12.50 → 12.5) and it can
// be used in further math. Never throws: null / undefined / NaN / garbage
// strings all come back as 0 — unlike the raw `value.toFixed(2)` idiom this
// replaces, which crashes on missing values.
//
// Templates and components should use the BaseMixin `round` delegate;
// plain JS modules import this directly.
export const round = (value, decimals = 2) => {
    const n = parseFloat(value);
    if (!Number.isFinite(n)) return 0;
    return +n.toFixed(decimals);
};

// For a value that may be missing, like a food's micronutrient: blank stays blank, anything else is rounded.
export const roundOrBlank = (value, decimals = 2) => (value == null || value === '' ? value : round(value, decimals));
